import { BusSelectorMobile } from '@/react-pages/Prices/TransportSelector/BusSelector/BusSelectorMobile';
import { BusSelectorDesktop } from '@/react-pages/Prices/TransportSelector/BusSelector/BusSelectorDesktop';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';

export const BusSelector = () => {
  const { isDesktopSm } = useBreakpoints();
  return <>{isDesktopSm ? <BusSelectorDesktop /> : <BusSelectorMobile />}</>;
};
